<dashboardnav>
    <cradua-loss-of-use-items
    [lossOfUseItemss]="lossOfUseItemss$ | async"
    [measurelist]="measurelist$ | async"
    (lossOfUseItems)="onSubmitLossOfUseItems($event)"
    (deleteLossOfUseItemsEvent)="onDeleteLossOfUseItems($event)"    
    *ngIf="
    !(isLoadingLossOfUseItems$ | async ) &&
    !(isLoadingUom$ | async )
    "
    >
  </cradua-loss-of-use-items>

    <mrsoftapps-epims-reference-spinner 
    *ngIf="
  (isLoadingLossOfUseItems$ | async ) ||
  (isLoadingUom$ | async )
  "
  >
    </mrsoftapps-epims-reference-spinner>
    <!-- <pre>{{isLoading$ | async | json}}</pre> -->
  </dashboardnav>
